import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from "react-leaflet";
import L from "leaflet";

// Fix default icon paths (leaflet with webpack)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const truckIcon = L.divIcon({
  className: "custom-truck-marker",
  html: `<div style="position:relative;">
    <div style="position:absolute;top:-8px;left:-8px;width:36px;height:36px;background:rgba(255,90,0,0.25);border-radius:50%;" class="pulse-dot"></div>
    <div style="width:20px;height:20px;background:#FF5A00;border:2px solid #09090b;transform:rotate(45deg);"></div>
  </div>`,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});

const warehouseIcon = L.divIcon({
  className: "custom-warehouse-marker",
  html: `<div style="width:18px;height:18px;background:#09090b;border:3px solid #fff;box-shadow:0 0 0 1px #09090b;"></div>`,
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

const destIcon = L.divIcon({
  className: "custom-dest-marker",
  html: `<div style="width:18px;height:18px;background:#16a34a;border:3px solid #fff;box-shadow:0 0 0 1px #09090b;border-radius:50%;"></div>`,
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length < 2) return;
    const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
    map.fitBounds(bounds, { padding: [40, 40] });
  }, [map, points]);
  return null;
}

export default function DeliveryMap({ tracking }) {
  if (!tracking?.destination) {
    return (
      <div className="w-full h-full bg-zinc-100 flex items-center justify-center border border-zinc-900">
        <div className="tag">Map unavailable</div>
      </div>
    );
  }

  const warehouse = tracking.warehouse_location;
  const dest = tracking.destination;
  const driver = tracking.driver_location || warehouse;

  const points = [warehouse, dest, driver];

  return (
    <div className="w-full h-full border border-zinc-900" data-testid="delivery-map">
      <MapContainer
        center={[driver.lat, driver.lng]}
        zoom={11}
        style={{ height: "100%", width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://osm.org/copyright">OSM</a>'
        />
        <Marker position={[warehouse.lat, warehouse.lng]} icon={warehouseIcon}>
          <Popup>Warehouse · Mumbai</Popup>
        </Marker>
        <Marker position={[dest.lat, dest.lng]} icon={destIcon}>
          <Popup>Delivery destination</Popup>
        </Marker>
        <Marker position={[driver.lat, driver.lng]} icon={truckIcon}>
          <Popup>Driver — ETA {tracking.eta_display}</Popup>
        </Marker>
        <Polyline
          positions={[
            [warehouse.lat, warehouse.lng],
            [driver.lat, driver.lng],
            [dest.lat, dest.lng],
          ]}
          pathOptions={{ color: "#FF5A00", weight: 3, dashArray: "6 6" }}
        />
        <FitBounds points={points} />
      </MapContainer>
    </div>
  );
}
